import { render, staticRenderFns } from "./productsCat.vue?vue&type=template&id=4baf519a&"
import script from "./productsCat.vue?vue&type=script&lang=js&"
export * from "./productsCat.vue?vue&type=script&lang=js&"
import style0 from "./productsCat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports